/* tslint:disable */

declare var Object: any;
export interface SFChangePrivacyInterface {
  "id"?: number;
}

export class SFChangePrivacy implements SFChangePrivacyInterface {
  "id": number;
  constructor(data?: SFChangePrivacyInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFChangePrivacy`.
   */
  public static getModelName() {
    return "SFChangePrivacy";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFChangePrivacy for dynamic purposes.
  **/
  public static factory(data: SFChangePrivacyInterface): SFChangePrivacy{
    return new SFChangePrivacy(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFChangePrivacy',
      plural: 'SFChangePrivacies',
      path: 'SFChangePrivacies',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFChangePrivacy.ts